import { Stack } from "PFComponents/containers";
import Hr from "PFComponents/hr";
import { Activity } from "PFTypes/activity";

import { ResourceTableToggleContainer } from "./resource_table_toggle_container";
import { SuggestedShortlistsTable } from "./suggested_shortlists_table";
import { isOpenVacancyItem } from "./suggested_shortlists_table/types";
import { useSuggestedShortlistItems } from "./suggested_shortlists_table/use_suggested_shortlist_items";

type SuggestedWMSidePanelContentProps = {
  activity: Activity;
};

export const SuggestedWMSidePanelContent = ({ activity }: SuggestedWMSidePanelContentProps) => {
  const {
    tableData: suggestedShortlistsTableData,
    isLoading,
    isFetching,
    isError
  } = useSuggestedShortlistItems(activity);
  const openVacancyItemsCount = suggestedShortlistsTableData.filter(isOpenVacancyItem).length;
  const canSuggest = openVacancyItemsCount > 0;

  return (
    <Stack gap="spacingLg">
      {!isError && (
        <SuggestedShortlistsTable
          tableData={suggestedShortlistsTableData}
          isLoading={isLoading}
          isFetching={isFetching}
        />
      )}
      <Hr noMargin />
      <ResourceTableToggleContainer activity={activity} canSuggest={canSuggest} />
    </Stack>
  );
};
